import * as React from 'react';
const PruritoIntimoMaschileIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M100 79.21v2.73M73.13 58.95s3.44 7.87 4.25 17.57c1.03 12.34-3.05 24.7-7.97 36.08-4.87 11.27-1.06 19.73.58 28.45M126.87 58.95s-3.44 7.87-4.25 17.57c-1.03 12.34 3.05 24.7 7.97 36.08 4.87 11.27 1.06 19.73-.58 28.45M105.59 131.15c1.02 3.35 2.46 6.88 4.52 9.9M94.42 131.15c-1.02 3.35-2.46 6.88-4.52 9.9"
      className="prefix__cls-2"
    />
    <path
      d="M72.59 104.69c1.43.23 9.09 1.55 14.42 4.39M76.89 88.67c3.28 1.21 12.18 4.06 23.11 4.06s19.83-2.85 23.11-4.06"
      className="prefix__cls-2"
    />
    <path
      d="m109.7 102.95 3.97-5.34M114.03 108.61l6.19-4.08M117.55 114.81l6.45-1.53"
      className="prefix__cls-1"
    />
    <circle cx={100.06} cy={116.96} r={8.18} className="prefix__cls-1" />
    <circle cx={100.06} cy={116.96} r={1.17} className="prefix__cls-1" />
  </svg>
);
export default PruritoIntimoMaschileIcon;
